// 글로벌 이커머스 주요 컨설팅 범위 슬라이드 이동 드래그 적용
document.addEventListener('DOMContentLoaded', function() {
  const sliders = document.querySelectorAll('.b7slider');
  sliders.forEach(function(slider) {
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      slider.classList.add('dragging');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mouseup', () => {
      isDown = false;
      slider.classList.remove('dragging');
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });

    // 모바일
    slider.addEventListener('touchstart', (e) => {
      isDown = true;
      startX = e.touches[0].pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('touchend', () => {
      isDown = false;
    });

    slider.addEventListener('touchmove', (e) => {
      if (!isDown) return;
      const x = e.touches[0].pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      slider.scrollLeft = scrollLeft - walk;
    });
  });
});


// 공통 함수: 모바일 조건에서 슬라이드 간격 적용 
function applyMobileGap({ selector, cellSelector, maxWidth, gap }) {
  const section = document.querySelector(selector);
  if (!section) return;

  const cells = section.querySelectorAll(cellSelector);
  const isMobile = window.innerWidth <= maxWidth;

  cells.forEach(cell => {
    cell.style.marginRight = isMobile ? `${gap}px` : '';
  });
}

// 적용할 섹션들 설정 // 여기서 슬라이드 간격 수정하시면 됩니다!
const mobileGapSettings = [
  {
    // 물류 대행 - 진행절차 슬라이드 (maxWidth = 1023px 이하, gap = 40px 간격)
    selector: 'div[id*="b7_process_jHdyYT"]',
    cellSelector: '.process_conts',
    maxWidth: 1023,
    gap: 16
  },
  {
    // 마케팅 - 마케팅 도구 슬라이드 (maxWidth = 1023px 이하, gap = 20px 간격)
    selector: 'div[id*="b7_col_with_bg_Jd6Cz9"]',
    cellSelector: '.columns-list',
    maxWidth: 1023,
    gap: 16
  },
  {
    // 운영 대행 - 운영대행 강점 슬라이드 (maxWidth = 1023px 이하, gap = 20px 간격)
    selector: 'div[id*="b7_col_with_bg_PGeF6Y"]',
    cellSelector: '.columns-list',
    maxWidth: 1023,
    gap: 16
  },
    {
    // 채용 공고 - 복지여정 슬라이드 (maxWidth = 1023px 이하, gap = 20px 간격)
    selector: '#shopify-section-template--19787695653108__b7_col_with_bg_aT4Hj7',
    cellSelector: '.columns-list',
    maxWidth: 1023,
    gap: 24
  }
];

// 모든 설정 반복 적용
function updateAllMobileGaps() {
  mobileGapSettings.forEach(setting => applyMobileGap(setting));
}

// 초기 실행 + 리사이즈 대응
updateAllMobileGaps();
window.addEventListener('resize', updateAllMobileGaps);




// partners 파트너스 내부링크/외부링크 분기
document.addEventListener('DOMContentLoaded', function () {
  let linkClasses = ['article-card__link', 'article-card__title'];

  linkClasses.forEach(function(className) {
    document.querySelectorAll('a.' + className).forEach(function(link) {
      if (link.href.includes('bridge7.co.kr')) {
        link.setAttribute('target', '_self'); 
      } 
      else {
        link.setAttribute('target', '_blank'); 
        link.setAttribute('rel', 'noopener noreferrer');
      }
    });
  });
});




